import mapboxgl from 'mapbox-gl';
import * as m from "./mapInit";
import * as ch from "./contentHelper";
import * as p from "./popup";
import $ from "jquery";

//--------------------------------------------------------------
//WEALTH
let headline = 'Wealth & Employment';
let addClassName = 'wealth';

let mapLayerNames = [
  'nuts3-wealth-1',
  'nuts3-wealth-2',
  'nuts3-wealth-3',
  'nuts3-wealth-4',
  'nuts3-wealth-5'
];
//add layers to toggleAbleLayers in mapInit
mapLayerNames.forEach(function(layerName){m.addToggleableLayer(layerName);});

let properties = [
  [
  'gdp-1-current-euro',
  'gdp-2-current-ppp',
  'gdp-at-current-2016',
  'gdp-variation-2010-2016',
  'unemployment-1-2017',
  'unemployment-2-average-popup-only'
  ],

  [
  'gdp-2-current-ppp',
  'gdp-1-current-euro',
  'gdp-at-current-2016',
  'gdp-variation-2010-2016',
  'unemployment-1-2017',
  'unemployment-2-average-popup-only'
  ],

  [
  'gdp-at-current-2016',
  'gdp-1-current-euro',
  'gdp-2-current-ppp',
  'gdp-variation-2010-2016',
  'unemployment-1-2017',
  'unemployment-2-average-popup-only'
  ],

  [
  'gdp-variation-2010-2016',
  'gdp-1-current-euro',
  'gdp-2-current-ppp',
  'gdp-at-current-2016',
  'unemployment-1-2017',
  'unemployment-2-average-popup-only'
  ],

  [
  'unemployment-1-2017',
  'unemployment-2-average-popup-only',
  'gdp-1-current-euro',
  'gdp-2-current-ppp',
  'gdp-at-current-2016',
  'gdp-variation-2010-2016'
  ]

];

let valueNames = [
  [
  'Gross Domestic Product<br/>[€ per inhabitant in % of the EU average], 2017',
  'Purchasing power standard [PPS]<br/>[per inhabitant in % of the EU average], 2017',
  'GDP at current market prices [millions €], 2016',
  'GDP Variation [2016 compared to 2010 in %]',
  'Unemployment<b/>[as a share of the active population], 2017',
  'Unemployment rate national average<br/>[as a share of the active population], 2017'
  ],

  [
  'Purchasing power standard [PPS]<br/>[per inhabitant in % of the EU average], 2017',
  'Gross Domestic Product<br/>[€ per inhabitant in % of the EU average], 2017',
  'GDP at current market prices [millions €], 2016',
  'GDP Variation [2016 compared to 2010 in %]',
  'Unemployment<b/>[as a share of the active population], 2017',
  'Unemployment rate national average<br/>[as a share of the active population], 2017'
  ],

  [
  'GDP at current market prices [millions €], 2016',
  'Gross Domestic Product<br/>[€ per inhabitant in % of the EU average], 2017',
  'Purchasing power standard [PPS]<br/>[per inhabitant in % of the EU average], 2017',
  'GDP Variation [2016 compared to 2010 in %]',
  'Unemployment<b/>[as a share of the active population], 2017',
  'Unemployment rate national average<br/>[as a share of the active population], 2017'
  ],

  [
  'GDP Variation [2016 compared to 2010 in %]',
  'Gross Domestic Product<br/>[€ per inhabitant in % of the EU average], 2017',
  'Purchasing power standard [PPS]<br/>[per inhabitant in % of the EU average], 2017',
  'GDP at current market prices [millions €], 2016',
  'Unemployment<b/>[as a share of the active population], 2017',
  'Unemployment rate national average<br/>[as a share of the active population], 2017'
  ],

  [
  'Unemployment<b/>[as a share of the active population], 2017',
  'Unemployment rate national average<br/>[as a share of the active population], 2017',
  'Gross Domestic Product<br/>[€ per inhabitant in % of the EU average], 2017',
  'Purchasing power standard [PPS]<br/>[per inhabitant in % of the EU average], 2017',
  'GDP at current market prices [millions €], 2016',
  'GDP Variation [2016 compared to 2010 in %]'
  ]
];

let valueDescriptions = [
  ['', '', '', '', '', ''],
  ['', '', '', '', '', ''],
  ['', '', '', '', '', ''],
  ['', '', '', '', '', ''],
  ['', '', '', '', '', ''],
  ['', '', '', '', '', '']
];

let infoBox = [
  [
  '',
  '',
  '',
  '',
  'Source: Eurostat:<br/> Unemployment rate by NUTS 2 regions',
  ''
  ],

  [
  '',
  '',
  '',
  '',
  'Source: Eurostat:<br/> Unemployment rate by NUTS 2 regions',
  ''
  ],

  [
  '',
  '',
  '',
  '',
  'Source: Eurostat:<br/> Unemployment rate by NUTS 2 regions',
  ''
  ],

  [
  '',
  '',
  '',
  '',
  'Source: Eurostat:<br/> Unemployment rate by NUTS 2 regions',
  ''
  ],

  [
  'Source: Eurostat:<br/> Unemployment rate by NUTS 2 regions',
  '',
  '',
  '',
  '',
  '',
  ],

];

let addTextAfterValue = [
  ['%','%','','%','%','%'],
  ['%','%','','%','%','%'],
  ['','%','%','%','%','%'],
  ['%','%','%','','%','%'],
  ['%','%','%','%','','%']
];

//--------------------------------------------------------------

for(let i = 0; i < properties.length; i++){
  m.map.on('click',mapLayerNames[i], function (e) {
    p.getPopup(
      e,
      addClassName,
      headline,
      properties[i],
      valueNames[i],
      valueDescriptions[i],
      infoBox[i],
      addTextAfterValue[i] );
  });
};